export default __webpack_public_path__ + "static/media/cl5.e0b65fdd.jpg";